import axios from "axios";
import {IRate} from "./Rates.types";

export default class RateApi {
    static async createRate(values:any) {
        try {
            let res = await axios.post(`/Rates`, values);
            return res.data;
        } catch (e: any) {
            console.error('Could not create rate: ', e.message);
            return undefined;
        }
    }

    static async getData({queryKey}: any) {
        //eslint-disable-next-line
        const [_, rawQuery] = queryKey;
        try {
            let res = await axios.get(`/Rates`, {params: rawQuery});
            return res.data as IRate[];
        } catch (e: any) {
            console.error('Could not get Rates data: ', e.message);
            return undefined;
        }
    }

    static async changeRateStatus(aglContractId:string, approved:true|false){
        try {
            let res = await axios.post(`/Rates/Approve`, {aglContractId, approved});
            return res.data as IRate;
        } catch (e: any) {
            console.error('Could not get change rate approval: ', e.message);
            return undefined;
        }
    }
}